import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';

const FeatureManager = () => {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchFeatures();
  }, []);

  const fetchFeatures = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('feature_flags')
        .select('*')
        .order('key');
      if (error) throw error;
      setFeatures(data);
    } catch (error) {
      console.error('Error fetching features:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleFeature = async (key, currentStatus) => {
    try {
      const { error } = await supabase
        .from('feature_flags')
        .update({ is_enabled: !currentStatus })
        .eq('key', key);
      if (error) throw error;
      fetchFeatures(); // Reload list
    } catch (error) {
      console.error('Error updating feature:', error);
      alert('Failed to update feature');
    }
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
      <h2 style={{ color: 'var(--color-text)', marginBottom: '20px', borderBottom: '1px solid var(--color-border)', paddingBottom: '10px' }}>🛠 Feature Flags (Maintenance)</h2>
      {loading ? <p>Loading...</p> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {features.map((feature) => (
            <div key={feature.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px', border: '1px solid var(--color-border)', borderRadius: '8px', backgroundColor: feature.is_enabled ? '#fff' : 'var(--color-surface-muted)' }}>
              <div>
                <h4 style={{ margin: '0 0 5px 0', color: feature.is_enabled ? 'var(--color-text)' : 'var(--color-text-subtle)' }}>{feature.label || feature.key}</h4>
                <p style={{ margin: 0, fontSize: '12px', color: 'var(--color-text-muted)' }}>{feature.description}</p>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '12px', color: feature.is_enabled ? 'var(--color-primary)' : '#d32f2f', fontWeight: 'bold' }}>
                    {feature.is_enabled ? 'ONLINE' : 'OFFLINE'}
                </span>
                <button
                  onClick={() => toggleFeature(feature.key, feature.is_enabled)}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '20px',
                    border: 'none',
                    cursor: 'pointer',
                    backgroundColor: feature.is_enabled ? '#ffebee' : 'var(--color-primary-soft)',
                    color: feature.is_enabled ? '#d32f2f' : 'var(--color-primary)',
                    fontWeight: 'bold',
                    minWidth: '80px'
                  }}
                >
                  {feature.is_enabled ? 'Disable' : 'Enable'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FeatureManager;
